import SubscriptionContractModelBase from '../_generated/modelBases/subscription-contract-model-base';

export default class SubscriptionContractModel extends SubscriptionContractModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
